import {RuleSource} from "@/ai-assistant/interfaces";

/**
 * A figure as the decision layer measured it, unit included.
 *
 * Values are printed, never recombined: a total or a percentage assembled in
 * the renderer would be a figure the server's guard never saw. And a missing
 * side prints as a dash rather than as nothing — an empty cell beside an arrow
 * reads as zero, where the truth is that nobody measured it.
 */
export const measure = (value: number | string | null | undefined, unit?: string | null): string =>
    value === null || value === undefined ? '—' : `${value}${unit ? ` ${unit}` : ''}`;

/**
 * The text a rule rests on, as the pharmacist checks it.
 *
 * Empty while the rule cannot name it: the corpus is not delivered, so the
 * only rule in force today supplies no article at all, and an em dash leading
 * nowhere reads as a reference that failed to load.
 */
export const sourceLabel = (source?: RuleSource | null): string => {
    if (!source?.article) {
        return '';
    }

    return source.in_force_since
        ? `${source.article}, en vigueur depuis le ${source.in_force_since}`
        : source.article;
};
